import { Controller } from "@hotwired/stimulus"

// The flash toast: shows on load and fades out after its delay (longer for
// an error).
export default class extends Controller {
  static values = { delay: { type: Number, default: 3200 } }

  connect() {
    this.timer = setTimeout(() => this.close(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  close() {
    clearTimeout(this.timer)
    this.element.classList.remove("show")
  }
}
